// extracted by mini-css-extract-plugin
export default {"select-pill-wrapper":"styles_select-pill-wrapper__ut0GQ","arrow-right-icon":"styles_arrow-right-icon__EOYLW","div-pill":"styles_div-pill__6E-t-","versus":"styles_versus__1h7Mb"};